<template>
  <div class="apply">
    <div v-if="!isSuccess">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleFormRef"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item prop="company">
          <el-input
            v-model="ruleForm.company"
            type="text"
            placeholder="请输入企业全称"
            prefix-icon="iconfont iconqita-4qiye_1"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="industryId">
          <el-select
            class="selectIndustry"
            filterable
            @change="industryFunc"
            v-model="ruleForm.industryId"
            placeholder="请选择所在行业"
          >
            <el-option
              v-for="item in industryList"
              :key="item.industryId"
              :label="item.name"
              :value="item.industryId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="name">
          <el-input
            v-model="ruleForm.name"
            autocomplete="off"
            type="text"
            placeholder="请输入姓名"
            prefix-icon="iconfont iconqita-3yonghu_1"
          ></el-input>
        </el-form-item>
        <el-form-item prop="position">
          <el-input
            v-model="ruleForm.position"
            autocomplete="off"
            type="text"
            placeholder="请输入您的职位"
            prefix-icon="iconfont iconqita-3zhiwei"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input
            type="text"
            v-model="ruleForm.phone"
            autocomplete="off"
            @change="phoneFunc"
            placeholder="请输入手机号"
            prefix-icon="iconfont iconqita-1shouji_1"
            :disabled="phoneInp"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            type="text"
            v-model="ruleForm.code"
            autocomplete="off"
            placeholder="请输入手机验证码"
            style="width:285px;"
            prefix-icon="iconfont iconqita-2yanzhengma_1"
          ></el-input>
          <el-button
            id="codeRef"
            ref="codeButton"
            :disabled="showGetCode"
            @click="onGetCode"
            class="defaultButtonClass"
            >{{ this.codeText }}</el-button
          >
        </el-form-item>
        <!-- :rules="{ required: true, message: '请选择', trigger: 'change' }" -->
        <el-form-item>
          <el-select
            class="selectSystem"
            @change="changeFunc"
            @remove-tag="removeFunc"
            multiple
            no-data-text="暂无数据，请先输入手机号"
            v-model="appId"
            placeholder="请选择试用系统"
          >
            <el-option-group v-for="group in options" :key="group.label" :label="group.label">
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submitBtnLoading" @click="submitForm">提交</el-button>
        </el-form-item>
      </el-form>
      <!-- 申请试用成功后的登录框 -->
      <!-- <el-dialog
      title="申请试用成功!"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      :visible.sync="loginDialogVisible"
      width="500px"
      :show-close="false"
    >
      <el-alert
        style="margin-bottom:16px;"
        show-icon
        center
        title="请点击登录或返回到登录页进行登录"
        type="success"
        :closable="false"
      ></el-alert>
      <el-form label-width="40px" ref="paramsFormRef" :model="paramsForm" class="login-form">
        <el-form-item prop="account" label="账号">
          <el-input
            disabled
            v-model.trim="paramsForm.account"
            prefix-icon="el-icon-mobile-phone"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input disabled v-model="paramsForm.password" prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          style=" width: 100%;margin-bottom: 16px;"
          round
          type="primary"
          :loading="loginBtnLoading"
          @click="handleLogin"
          >登录</el-button
        >
        <p
          class="go-back"
          style=" text-align: center; font-size: 12px;color: #ccc;cursor: pointer;"
          @click="goLoginPage"
        >
          已记住账号密码，点击此处返回登录页
        </p>
      </div>
    </el-dialog> -->
    </div>
    <div v-else>
      <div class="successDiv">
        <div class="successIcon">
          <img src="~@/assets/images/success.png" alt="" />
        </div>
        <div class="tips">申请已提交，待管理员审核通过后即可试用系统</div>
        <div class="jump">{{ time }} 后跳转至登录页</div>
      </div>
      <el-button class="successBtn" type="primary" @click="routerJump" round
        >立即返回登录页</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import commonApi from 'api/common';
import registerApi from 'api/register/register.js';
import config from '@/config/index';

export default {
  data() {
    /* 手机号验证 */
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        this.showGetCode = true;
        callback(new Error('请输入手机号'));
      } else if (!/^[0123456789]\d{10}$/.test(value)) {
        this.showGetCode = true;
        callback(new Error('请输入正确的手机号'));
      } else {
        //   // 检验手机号唯一性
        // commonApi
        //   .checkPhoneUnique({
        //     phone: value
        //   })
        //   .then(res => {
        //     if (res.data.code === 200) {
        this.showGetCode = false;
        //       callback();
        //     } else {
        //       this.showGetCode = true;
        //       callback(new Error('该手机号已存在，请重新输入'));
        //     }
        //   });
        this.getApp();
        callback();
      }
    };
    /* 姓名验证 */
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入姓名'));
      } else if (!/^[\u4E00-\u9FA5]+$/.test(value)) {
        callback(new Error('只能是中文'));
      } else if (value.length > 10) {
        callback(new Error('最多输入10个汉字'));
      } else {
        callback();
      }
    };
    /* 职位验证 */
    var position = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入您的职位'));
      } else if (value.length > 20) {
        callback(new Error('最多输入20位'));
      } else {
        callback();
      }
    };
    /* 企业名称验证 */
    var validateCompany = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入组织机构全称'));
      } else if (value.length > 50) {
        callback(new Error('最大输入50个中文!'));
      } else {
        callback();
      }
    };
    /* 手机验证码验证 */
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机验证码'));
      } else if (!/^[0123456789]\d{5}$/.test(value)) {
        callback(new Error('请输入正确的验证码'));
      } else {
        callback();
      }
    };

    return {
      options: [],
      value: '',
      config,
      /* 步骤一表单数据 */
      ruleForm: {
        phone: '',
        code: '',
        name: '',
        company: '',
        industryName: '',
        industryId: '',
        userId: '',
        appId: '',
        position: ''
      },
      appId: [],
      industryList: [],
      submitBtnLoading: false,
      showGetCode: true, // 获取验证码
      codeText: '获取验证码',
      countDown: 60,
      noInp: false,
      phoneInp: false,
      rules: {
        phone: [{ validator: validatePhone, trigger: 'change', required: true }],
        name: [{ validator: checkName, trigger: 'blur', required: true }],
        position: [{ validator: position, trigger: 'blur', required: true }],
        company: [{ validator: validateCompany, trigger: 'blur', required: true }],
        code: [{ validator: validateCode, trigger: 'blur', required: true }],
        appId: [{ required: true, message: '请选择', trigger: 'change' }],
        industryId: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      loginDialogVisible: false,
      loginBtnLoading: false,
      paramsForm: {
        account: '',
        password: ''
      },
      isSuccess: false,
      time: 0,
      timeFunc: null,
      isChange: true
    };
  },
  created() {
    // this.getApp();
    this.getIndustryList();
  },
  methods: {
    ...mapActions(['login', 'getUserInfo']),
    /* 倒计时 */
    countDownTime() {
      if (!this.countDown) {
        document.getElementById('codeRef').style.background = '#f56c6c';
        this.showGetCode = false;
        this.countDown = 60;
        this.noInp = false;
        this.phoneInp = false;
        this.codeText = '获取验证码';
        return;
      } else {
        this.showGetCode = true;
        this.codeText = '(' + this.countDown + 's' + ')';
        this.countDown--;
      }
      setTimeout(() => {
        this.countDownTime();
      }, 1000);
    },
    // // 企业模糊搜索
    // querySearch(queryString, cb) {
    //   registerApi.getOrgListByName(queryString).then(res => {
    //     if (res.data.code === 200) {
    //       cb(res.data.data);
    //     }
    //   });
    // },
    // // 选择企业
    // handleSelect(item) {
    //   this.ruleForm.company = item.orgName;
    // },
    /* 提交按钮 */
    submitForm() {
      this.isChange = false;
      this.submitBtnLoading = true;
      this.ruleForm.appId = this.appId.join(',');
      this.$refs.ruleFormRef.validate(valid => {
        if (!valid) {
          this.submitBtnLoading = false;
          return;
        }
        // 短信验证码验证
        commonApi
          .postCheckMessageCode({
            phone: this.ruleForm.phone,
            validateCode: this.ruleForm.code
          })
          .then(res => {
            if (res.data.code === 200) {
              // 验证不通过
              if (!res.data.data) {
                this.submitBtnLoading = false;
                this.$message({
                  message: '短信验证码验证失败，请检查后重新输入',
                  type: 'error',
                  duration: 4000
                });
              } else {
                if (!this.ruleForm.appId) {
                  this.$message({
                    message: '请选择使用系统',
                    type: 'error',
                    duration: 4000
                  });
                } else {
                  // 验证成功
                  registerApi.postTrialUser(this.ruleForm).then(res => {
                    if (res.data.code === 200) {
                      this.$message({
                        message: '申请试用成功',
                        type: 'success'
                      });
                      // this.paramsForm.account = config.trial_accounts;
                      // this.paramsForm.password = config.trial_password;
                      // this.loginDialogVisible = true;
                      this.isSuccess = true;
                      this.time = 5;
                      this.timeFunc = setInterval(() => {
                        --this.time;
                        if (this.time < 0) {
                          this.$router.push('/login');
                          clearInterval(this.timeFunc);
                        }
                      }, 1000);
                    } else {
                      this.$message({
                        message: res.data.message,
                        type: 'error'
                      });
                    }
                  });
                }
                this.submitBtnLoading = false;
              }
            }
          });
      });
    },
    /* 获取验证码 */
    onGetCode() {
      this.noInp = true;
      this.phoneInp = true;
      this.countDownTime();
      commonApi
        .postSendMessage({
          phone: this.ruleForm.phone,
          templateCode: 'SMS_204981651'
        })
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: '短信验证码发送成功，请注意查收',
              type: 'success'
            });
          }
          // else {
          //   this.$message.error(res.data.message);
          // }
        });
    },
    // 返回登录页
    goLoginPage() {
      this.$router.replace('/login');
    },
    // 登录试用账号
    handleLogin() {
      this.loginBtnLoading = true;
      this.login(this.paramsForm)
        .then(res => {
          // 登录成功，获取用户信息
          this.getUserInfo().then(() => {
            this.loginBtnLoading = false;
            this.$message({
              message: '登录成功',
              type: 'success'
            });
            if (this.userInfo.adminType === 1) {
              this.$router.push('/home');
            } else {
              // 子系统超级管理员 或 普通用户
              this.$router.push('/register/systemselect');
            }
          });
        })
        .catch(error => {
          this.loginBtnLoading = false;
        });
    },
    routerJump() {
      clearInterval(this.timeFunc);
      this.$router.push('/login');
    },
    getApp() {
      if (this.isChange) {
        this.appId = [];
      }
      commonApi.getApp({ phone: this.ruleForm.phone }).then(res => {
        if (res.data.code === 200) {
          this.options = this.$options.data().options;
          this.ruleForm.userId = res.data.data?.userId;
          this.options = res.data.data.appData;
        }
      });
    },
    getIndustryList() {
      commonApi.chooseIndustryList().then(res => {
        if (res.data.code === 200) {
          this.industryList = res.data.data;
        }
      });
    },
    trialDataFunc(e, isVal) {
      let lengthData;
      if (typeof e == 'string') {
        lengthData = e;
      } else {
        lengthData = e[e.length - 1];
      }
      let keyi = '';
      let keyData = {};
      let keyk = '';
      for (let k = 0, y = this.options.length; k < y; k++) {
        let sfyzd = false;
        let dataoneList = this.options[k];
        for (let key in dataoneList) {
          if (dataoneList[key] && dataoneList[key].length > 0) {
            let dataList = dataoneList[key];
            for (let i = 0, j = dataList.length; i < j; i++) {
              if (dataList[i].value == lengthData) {
                keyi = key;
                keyData = dataList;
                sfyzd = true;
                keyk = k;
                break;
              }
            }
          }
          if (sfyzd) {
            break;
          }
        }
        if (sfyzd) {
          break;
        }
      }
      keyData.forEach(item => {
        item.disabled = isVal;
      });
    },
    changeFunc(e) {
      this.trialDataFunc(e, true);
    },
    removeFunc(e) {
      this.trialDataFunc(e, false);
    },
    industryFunc(e) {
      this.industryList.forEach(item => {
        if (item.industryId == e) {
          this.ruleForm.industryName = item.name;
        }
      });
    },
    phoneFunc(e) {
      this.isChange = true;
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    showGetCode: function(newVal) {
      if (!newVal && !this.noInp) {
        document.getElementById('codeRef').style.background = '#f56c6c';
      } else {
        document.getElementById('codeRef').style.background = '#dcdfe7';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.apply {
  height: 625px;
  display: flex;
  justify-content: center;
  align-items: center;

  .demo-ruleForm {
    /deep/.el-input {
      width: 410px;
    }
    /deep/.el-input__inner::placeholder {
      color: #c0c4ce;
    }
    /deep/.el-button--primary {
      width: 410px;
      background: linear-gradient(90deg, #4189fd 0%, #409dff 100%);
      box-shadow: 0px 3px 6px rgba(64, 157, 255, 0.3);
      border-radius: 20px;
      margin-top: 56px;
    }
    /deep/.el-form-item {
      margin-bottom: 24px;
    }
    /* 默认灰色按钮 */
    .defaultButtonClass {
      width: 115px;
      display: inline-block;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      background: #dcdfe7;
      color: #fff;
      height: 40px;
      border: 0;
      margin-left: 10px;
    }
    /* 红色按钮 */
    .greyButtonClass {
      width: 115px;
      display: inline-block;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      background: #f56c6c;
      color: #fff;
      height: 40px;
      border: 0;
      margin-left: 10px;
    }
    .greyButtonClass:hover {
      cursor: pointer;
    }
    /deep/.el-input__inner {
      border-radius: 0;
    }
    /deep/.iconfont {
      font-size: 24px;
      color: #000;
    }
  }
  .successDiv {
    margin-bottom: 140px;
    .successIcon {
      margin: 0 auto 28px;
      width: 85px;
      height: 85px;
      background-color: #67c33a;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50px;
    }
    .tips {
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-weight: 400;
      color: #67c33a;
      text-align: center;
    }
    .jump {
      color: #90939b;
      text-align: center;
      margin-top: 11px;
    }
  }
  .successBtn {
    margin: 0 auto;
    width: 410px;
  }
}
.go-back:hover {
  color: #000;
}

.selectIndustry {
  /deep/.el-input__inner {
    //如果你的style 加了scoped 需要加/deep/
    background: url('~@/assets/images/qita.png') no-repeat; //引入icon
    background-size: 24px 24px; //这个是图片的大小，在这里不能直接设置width  height,设置宽高其实是select的宽高，图片可能会失真只设置宽度  高度auto也行
    background-position: 3px 7px; //在input中定位置  这两个参数是x  y坐标
    padding: 0 0 0 30px; //需要设置padding 把placeholder向右移
    box-sizing: border-box;
    font-size: 14px;
  }
}
.selectSystem {
  /deep/.el-input__inner {
    //如果你的style 加了scoped 需要加/deep/
    background: url('~@/assets/images/xitong.png') no-repeat; //引入icon
    background-size: 24px 24px; //这个是图片的大小，在这里不能直接设置width  height,设置宽高其实是select的宽高，图片可能会失真只设置宽度  高度auto也行
    background-position: 3px 7px; //在input中定位置  这两个参数是x  y坐标
    padding: 0 0 0 30px; //需要设置padding 把placeholder向右移
    box-sizing: border-box;
    font-size: 14px;
  }
}
/deep/.el-select-group__title {
  color: #303133;
  font-size: 15px;
  font-weight: 700;
}
</style>
